import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography
} from '@mui/material';
import { parseClassData, generateGoogleCalendarUrl, generateIcsFile, downloadIcsFile } from '../../utils/calendarExport';

interface AddToCalendarModalProps {
  open: boolean;
  classInfo: any;
  onClose: () => void;
}

const AddToCalendarModal: React.FC<AddToCalendarModalProps> = ({
  open,
  classInfo,
  onClose
}) => {
  const providerButtonSx = {
    py: 1.5,
    justifyContent: 'flex-start',
    pl: 2,
    bgcolor: 'rgb(200, 16, 46)',
    color: '#fff',
    borderColor: 'rgb(200, 16, 46)',
    '&:hover': {
      bgcolor: 'rgb(185, 28, 28)',
      borderColor: 'rgb(185, 28, 28)'
    }
  };

  const handleGoogleCalendar = () => {
    try {
      const parsedData = parseClassData(classInfo);
      const googleUrl = generateGoogleCalendarUrl(parsedData);
      window.open(googleUrl, '_blank');
      onClose();
    } catch (error) {
      console.error('Error opening Google Calendar:', error);
      alert('Error opening Google Calendar. Please try again.');
    }
  };

  const handleAppleCalendar = () => {
    try {
      const parsedData = parseClassData(classInfo);
      const icsContent = generateIcsFile(parsedData);
      if (!icsContent) {
        alert('Error generating calendar file. Please check the class details.');
        return;
      }
      downloadIcsFile(icsContent, `${parsedData.title.replace(/\s+/g, '-')}.ics`);
      onClose();
    } catch (error) {
      console.error('Error exporting to Apple Calendar:', error);
      alert('Error exporting to Apple Calendar. Please try again.');
    }
  };

  const handleOutlook = () => {
    try {
      const parsedData = parseClassData(classInfo);
      const icsContent = generateIcsFile(parsedData);
      if (!icsContent) {
        alert('Error generating calendar file. Please check the class details.');
        return;
      }
      downloadIcsFile(icsContent, `${parsedData.title.replace(/\s+/g, '-')}.ics`);
      onClose();
    } catch (error) {
      console.error('Error exporting to Outlook:', error);
      alert('Error exporting to Outlook. Please try again.');
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h6" component="div">
          Add to Calendar
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
            Choose your calendar provider to add this class event.
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            <Button
              variant="contained"
              fullWidth
              onClick={handleGoogleCalendar}
              sx={providerButtonSx}
            >
              <Typography>Google Calendar</Typography>
            </Button>

            <Button
              variant="contained"
              fullWidth
              onClick={handleAppleCalendar}
              sx={providerButtonSx}
            >
              <Typography>Apple Calendar</Typography>
            </Button>

            <Button
              variant="contained"
              fullWidth
              onClick={handleOutlook}
              sx={providerButtonSx}
            >
              <Typography>Outlook</Typography>
            </Button>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddToCalendarModal;

